import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, SearchParamError } from '@tanstack/react-router';
import { z } from 'zod';
import { getReactQueryOptions, isApiError } from '@_/utils-frontend';
import { publicApiQueryClient } from '#src/api.ts';
import {
  AcceptFamilyInviteErrorPage,
  AcceptFamilyInvitePage
} from '#src/pages/AcceptFamilyInvite/index.ts';
import { NotFoundPage } from '#src/pages/errorPages/NotFoundPage.tsx';

export const Route = createFileRoute('/{-$locale}/email-link_/_wrapper/accept-family-invite')({
  component: RouteComponent,
  errorComponent: ({ error }) => {
    if (error instanceof SearchParamError) {
      return <NotFoundPage />;
    }

    if (isApiError(error) && error.status === 404) {
      return <AcceptFamilyInviteErrorPage />;
    }

    throw error;
  },
  validateSearch: z.object({
    emailConfirmationId: z.string().trim().nonempty(),
    inviteId: z.string().trim().nonempty(),
    token: z.string().trim().nonempty()
  })
});

function RouteComponent() {
  const { emailConfirmationId, inviteId, token } = Route.useSearch();

  const inviteQuery = useSuspenseQuery(
    getReactQueryOptions(publicApiQueryClient.familyInvites.getReceivedInvite, {
      headers: { authorization: `Bearer ${token}` },
      params: { id: inviteId, emailConfirmationId }
    })
  );
  const invite = inviteQuery.data.data;

  return (
    <AcceptFamilyInvitePage
      emailConfirmationId={emailConfirmationId}
      invite={invite}
      token={token}
    />
  );
}
